// extracted by mini-css-extract-plugin
export default {"textArea":"text-area_textArea__P5FMf","error":"text-area_error__pkXQg"};